'use client'

import { confirm } from '@repo/ui/Confirm'
import { DeleteIcon } from '@repo/ui/DeleteIcon'
import { EditIcon } from '@repo/ui/EditIcon'
import { HoverActionsPill } from '@repo/ui/HoverActionsPill'
import { NotesForm } from '@repo/ui/NotesForm'
import { useMattersStore } from '@repo/store/useMattersStore'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'
import { useState } from 'react'
import MUIIconButton from '@mui/material/IconButton'
import MUIStack from '@mui/material/Stack'
import MUITooltip from '@mui/material/Tooltip'
import MUITypography from '@mui/material/Typography'
import PropTypes from 'prop-types'

export const NoteItem = ({ entityId, matterNoteId, notes, dateEntered }) => {
  const [isEditing, setIsEditing] = useState(false)
  const { deleteMatterNotes } = useMattersStore()
  const { allowedActions } = useMenuItemsStore()
  const allowEditNotes = allowedActions?.editNotes?.allowed || false

  const toggleEditMode = () => {
    setIsEditing(!isEditing)
  }

  const handleDelete = async () => {
    const proceed = await confirm('Are you sure you want to delete this note?')
    if (proceed) deleteMatterNotes({ clientMatterNo: entityId, matterNoteId })
  }

  return (
    <>
      <MUIStack
        data-testid="NoteItem"
        direction="row"
        key={`${matterNoteId}`}
        sx={{
          width: '100%',
          position: 'relative',
          '&:hover': { '.hoverActionsPill': { visibility: 'visible', opacity: 1 } }
        }}
      >
        {isEditing ? (
          <NotesForm
            entityId={entityId}
            matterNoteId={matterNoteId}
            matterNotes={notes}
            dateEntered={dateEntered}
            onCancel={toggleEditMode}
            onSubmitComplete={toggleEditMode}
          />
        ) : (
          <>
            <MUITypography
              variant="body1"
              data-testid="MatterNotesDrawer"
              sx={{
                padding: '20px',
                flex: 1,
                backgroundColor: '#F5F6F8',
                borderRadius: '6px',
                whiteSpace: 'pre-wrap'
              }}
            >
              {notes}
            </MUITypography>

            {allowEditNotes ? (
              <HoverActionsPill>
                <MUITooltip title="Edit note" arrow placement="top">
                  <MUIIconButton onClick={toggleEditMode} sx={{ width: '36px', height: '36px' }}>
                    <EditIcon sx={{ width: '18px', height: '18px' }} />
                  </MUIIconButton>
                </MUITooltip>
                <MUITooltip title="Delete note" arrow placement="top">
                  <MUIIconButton onClick={handleDelete} sx={{ width: '36px', height: '36px' }}>
                    <DeleteIcon sx={{ width: '18px', height: '18px' }} />
                  </MUIIconButton>
                </MUITooltip>
              </HoverActionsPill>
            ) : null}
          </>
        )}
      </MUIStack>
    </>
  )
}

NoteItem.propTypes = {
  entityId: PropTypes.string,
  matterNoteId: PropTypes.number,
  notes: PropTypes.string,
  dateEntered: PropTypes.any
}
